
import programList from '../components/programList'
import taskProgress from '../components/taskProgress'


export default {
  name: 'Programs',
  data() {
    return {
      activeName: 'a',
    }
  },
  mounted() {
    document.title = this.$t('append_field.program_management')
    this.activeName = this.$route.query.itemName
  },
  components: {
    programList,
    taskProgress
  },
  methods: {
    itemName(res) {
      this.activeName = res
    },
    onChange(event) {
      this.activeName = event;
    },
    changeItemShow(data) {
      this.activeName = data
    },
    title() {
      switch (this.activeName) {
        case 'a':
          return this.$t('append_field.program')
        case 'b':
          return this.$t('append_field.task')
        case 'c':
          return this.$t('append_field.progress')
      }
    }
  }
}
